import '.a{display:flex;}.ssr-plugin'
import '.ag{align-items:stretch;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.e1{background:var(--shades-white);}.ssr-plugin'
import '.c1{flex-grow:1;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.az{max-width:77.5rem;}.ssr-plugin'
import '.bt{justify-content:stretch;}.ssr-plugin'
import '.bu{position:sticky;}.ssr-plugin'
import '.bv{top:0px;}.ssr-plugin'
import '.bw{z-index:10;}.ssr-plugin'
import '.f2{padding-block:1rem;}.ssr-plugin'
import '.f3{height:3rem;}.ssr-plugin'
import '.a9{justify-content:space-between;}.ssr-plugin'
import '.bz{flex-wrap:wrap;}.ssr-plugin'
import '.f4{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.ax{margin-top:2rem;}.ssr-plugin'
import '.f5{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ag b e e1"
      >
        <div className="c1 a f b e"
        >
          <div className="az a e bt bu bv bw e1"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="f2 f3 a a9 f bz"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="f4 a e ag ax f5 az"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
